import axios from "axios";
import {Loading, Message} from 'element-ui';
import Router from '@/router'

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = process.env.VUE_APP_HOST;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';

let config = {};

const instance = axios.create(config);
let loading;

instance.interceptors.request.use(
    function (config) {
        const token = sessionStorage.getItem("auth-token");
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
        }

        loading = Loading.service({
            spinner: 'el-icon-loading',
            background: "rgba(0, 0, 0, 0.1)"
        });
        return config;
    },
    function (error) {
        loading.close();
        return Promise.reject(error);
    }
);

instance.interceptors.response.use(
    function (response) {
        loading.close();
        return response.data;
    },
    function (error) {
        loading.close();

        if (error.response) {
            const status = error.response.status;
            switch (status) {
                case 401:
                    Router.push("/login");
                    break;
                case 403:
                    Message.error("您不具有访问该服务的权限！");
                    break;
                case 404:
                    Message.error("请求地址不存在！");
                    break;
                default:
                    Message.error("服务异常！");
                    break;
            }
        }
        return Promise.reject(error);
    }
);

export default instance;
